import Cookie from 'js-cookie';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

import {Product} from 'src/app/shared/classes/product';

import {QuickViewComponent} from 'src/app/shared/components/modals/quick-view/quick-view.component';
import {QuickViewTwoComponent} from 'src/app/shared/components/modals/quick-view-two/quick-view-two.component';
import {NewsletterModalComponent} from '../components/modals/newsletter-modal/newsletter-modal.component';
import {LoginModalComponent} from '../components/modals/login-modal/login-modal.component';
import {VideoModalComponent} from '../components/modals/video-modal/video-modal.component';

import {environment} from 'src/environments/environment';
import {ShareDialogComponent} from '../components/modals/share-dialog/share-dialog.component';
import {SocialSharingDialogComponent} from '../components/modals/social-sharing-dialog/social-sharing-dialog.component';
import {WishList} from '../classes/app.models';
import {ForgotPasswordComponent} from '../components/modals/forgot-password/forgot-password.component';
import {WishlistDialogComponent} from '../components/modals/wishlist-dialog/wishlist-dialog.component';
import { AiLicensePopupComponent } from '../components/modals/ai-license-popup/ai-license-popup.component';
import { BANANA_AI_LICENSE_TEXT } from '../components/modals/ai-license-popup/ai-license/banana-ai-license';
import { NUR_AI_LICENSE_TEXT } from '../components/modals/ai-license-popup/ai-license/nur-ai-license';
import { SignInDialogComponent } from '../components/exclusive/sign-in-dialog/sign-in-dialog.component';
import { ExclusiveTeamComponent } from '../components/modals/exclusive-team/exclusive-team.component';

@Injectable({
    providedIn: 'root'
})

export class ModalService {
    products = [];
    timer: any;
    modalRef!: NgbModalRef;

    private modalOption1: NgbModalOptions = {
        centered: true,
        size: 'xl',
        windowClass: 'newsletter-modal',
        beforeDismiss: async () => {
            document.querySelector('body')?.classList.remove('modal-open');

            await new Promise((resolve) => {
                setTimeout(() => {
                    resolve('success');
                }, 250);
            });

            (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

            return true;
        }
    };

    private modalOption2: NgbModalOptions = {
        centered: true,
        size: 'lg',
        windowClass: 'login-modal',
        beforeDismiss: async () => {
            document.querySelector('body')?.classList.remove('modal-open');

            await new Promise((resolve) => {
                setTimeout(() => {
                    resolve('success');
                }, 300);
            });

            (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

            return true;
        }
    };

    private modalOption3: NgbModalOptions = {
        centered: true,
        size: 'xl',
        scrollable: false,
        windowClass: 'vb-modal',
        beforeDismiss: async () => {
            document.querySelector('body')?.classList.remove('modal-open');

            await new Promise((resolve) => {
                setTimeout(() => {
                    resolve('success');
                }, 300);
            });

            (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

            return true;
        }
    };

    private modalOption4: NgbModalOptions = {
        centered: true,
        size: 'xl',
        beforeDismiss: async () => {
            document.querySelector('body')?.classList.remove('modal-open');

            await new Promise((resolve) => {
                setTimeout(() => {
                    resolve('success');
                }, 300);
            });


            (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

            return true;
        }
    };

    constructor(private modalService: NgbModal, private router: Router, private http: HttpClient) {
    }

    openNewsletter() {
        if (this.timer) {
            window.clearTimeout(this.timer);
        }
        if (!Cookie.get(`hideNewsletter-${environment.demo}`)) {
            this.timer = window.setTimeout(() => {
                this.modalService.dismissAll();
                (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

                setTimeout(() => {
                    if (this.router.url === '/' && !document.querySelector('.newsletter-modal')) {
                        this.modalService.open(
                            NewsletterModalComponent,
                            this.modalOption1
                        );
                    }
                }, 400);
            }, 5000);
        }
    }

    openCashBack() {
      this.modalRef =  this.modalService.open(
            NewsletterModalComponent,
            this.modalOption1
        );
    }

    closeCashBack() {
        this.modalRef.close();
    }

    openExclusiveTeamModal() {
      this.modalRef =  this.modalService.open(
            ExclusiveTeamComponent,
            this.modalOption1
        );
    }

    // Show login modal
    showLoginModal() {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
        this.modalRef = this.modalService.open(
            LoginModalComponent,
            this.modalOption2
        );
    }

    showPremiumLoginModal() {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
         this.modalRef = this.modalService.open(
            SignInDialogComponent,
            this.modalOption2
        );
    }


    // Show Video modal
    showVideoModal(url: any = '') {
        const modalRef = this.modalService.open(
            VideoModalComponent,
            this.modalOption3
        );
        modalRef.componentInstance.url = url;
    }

    /**
     * Show Product in QuickView
     */
    public showQuickView(product: Product) {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

        const modalRef = this.modalService.open(
            QuickViewComponent,
            {
                ...this.modalOption4,
                windowClass: 'quickView-modal'
            }
        );

        modalRef.componentInstance.slug = product.slug;
    }

    /**
     * Show Product in QuickViewTwo
     */
    public showQuickViewTwo(product: Product) {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});

        const modalRef = this.modalService.open(
            QuickViewTwoComponent,
            {
                ...this.modalOption4,
                windowClass: 'quickView-modal'
            }
        );

        modalRef.componentInstance.slug = product.slug;
    }


    showShareModal(wishlist: WishList) {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
        const modalRef = this.modalService.open(
            ShareDialogComponent,
            this.modalOption2
        );
        modalRef.componentInstance.wishlist = wishlist;
    }

    showSocialSharingModal(share: any) {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
        const modalRef = this.modalService.open(
            SocialSharingDialogComponent,
            this.modalOption2
        );
        modalRef.componentInstance.share = share;
    }

    showWishListView(product: any) {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
        const modalRef = this.modalService.open(
            WishlistDialogComponent,
            this.modalOption2
        );
        modalRef.componentInstance.product = product;
    }

    // Show login modal
    showForgotPasswordModal() {
        (document.querySelector('.logo') as HTMLElement)?.focus({preventScroll: true});
        this.modalService.open(
            ForgotPasswordComponent,
            this.modalOption2
        );
    }


showAiLicenseModal(aiModel: 'BANANA_AI' | 'NUR_AI'): Promise<'ACCEPTED' | 'REJECTED' | 'CANCELLED'> {

    const licenseMap = {
        BANANA_AI: {
            title: 'Banana AI – License Terms',
            content: BANANA_AI_LICENSE_TEXT
        },
        NUR_AI: {
            title: 'IP Gen – Usage Terms',
            content: NUR_AI_LICENSE_TEXT
        }
    };

    const modalRef = this.modalService.open(
        AiLicensePopupComponent,
        {
            centered: true,
            size: 'lg',
            backdrop: 'static',
            keyboard: false,
            container: 'body',
            windowClass: 'ai-license-modal-window',
            backdropClass: 'ai-license-modal-backdrop'
        }
    );


    modalRef.componentInstance.title = licenseMap[aiModel].title;
    modalRef.componentInstance.content = licenseMap[aiModel].content;

    // Always RESOLVE (never reject now)
    return modalRef.result.then(
        (result) => result as 'ACCEPTED' | 'REJECTED' | 'CANCELLED',
        () => 'CANCELLED'
    );
}

}
